<!-- Start Client Logos Section -->
<div class="partner-area">
    <div class="container">
        <div class="partner-inner">
            <div class="row align-items-center">
                <div class="col-lg-3 col-sm-4 col-md-3 col-6">
                    <a href="#">
                        <img src="assets/img/clients/camccul-logo.png" alt="partner">
                        <img src="assets/img/clients/camccul-logo.png" alt="partner">
                    </a>
                </div>

                <div class="col-lg-3 col-sm-4 col-md-3 col-6">
                    <a href="#">
                        <img src="assets/img/clients/bapccul-logo.png" alt="partner">
                        <img src="assets/img/clients/bapccul-logo.png" alt="partner">
                    </a>
                </div>

                <div class="col-lg-3 col-sm-4 col-md-3 col-6">
                    <a href="#">
                        <img src="assets/img/clients/ccia-logo.png" alt="partner">
                        <img src="assets/img/clients/ccia-logo.png" alt="partner">
                    </a>
                </div>

                <div class="col-lg-3 col-sm-4 col-md-3 col-6">
                    <a href="#">
                        <img src="assets/img/clients/cepac-logo.png" alt="partner">
                        <img src="assets/img/clients/cepac-logo.png" alt="partner">
                    </a>
                </div>

                <div class="col-lg-3 col-sm-4 col-md-3 col-6">
                    <a href="#">
                        <img src="assets/img/clients/figec-logo.png" alt="partner">
                        <img src="assets/img/clients/figec-logo.png" alt="partner">
                    </a>
                </div>

                <div class="col-lg-3 col-sm-4 col-md-3 col-6">
                    <a href="#">
                        <img src="assets/img/clients/mitaccul-logo.png" alt="partner">
                        <img src="assets/img/clients/mitaccul-logo.png" alt="partner">
                    </a>
                </div>

                <div class="col-lg-3 col-sm-4 col-md-3 col-6">
                    <a href="#">
                        <img src="assets/img/clients/cpcd-logo.png" alt="partner">
                        <img src="assets/img/clients/cpcd-logo.png" alt="partner">
                    </a>
                </div>

                <div class="col-lg-3 col-sm-4 col-md-3 col-6">
                    <a href="#">
                        <img src="assets/img/clients/safi-logo.png" alt="partner">
                        <img src="assets/img/clients/safi-logo.png" alt="partner">
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Client Logos Section -->